import account from './account/store.js'

export default {
  namespaced: true,
  modules: {
    account: account
  }
}
